// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2b3b2fb","453":"7e1910e7","455":"108e315b","977":"004c5529"}[chunkId] + ".chunk.js";
};